package co.maytes.standupbot.dashboard.features.setup

import co.maytes.standupbot.shared.dto.integration.FixActionDto
import co.maytes.standupbot.shared.dto.setup.SetupItemDto
import co.maytes.standupbot.shared.dto.setup.SetupItemStateDto
import co.maytes.standupbot.shared.dto.setup.SetupStatusDto
import co.maytes.standupbot.shared.dto.setup.isComplete
import co.maytes.standupbot.shared.dto.setup.progressLabel

enum class SetupGlyph { Done, Warning, Broken, Todo, Optional }

data class SetupRow(
    val label: String,
    val detail: String?,
    val glyph: SetupGlyph,
    val action: FixActionDto?,
) {
    val isBroken: Boolean get() = glyph == SetupGlyph.Broken
}

data class SetupChecklistModel(
    val rows: List<SetupRow>,
    val progressLabel: String,
    val percent: Int,
    val collapsed: Boolean,
) {
    val collapsedLabel: String get() = "Setup complete"

    companion object {
        fun from(status: SetupStatusDto): SetupChecklistModel =
            SetupChecklistModel(
                rows = status.items.map(::row),
                progressLabel = status.progressLabel(),
                percent = status.percentComplete,
                collapsed = status.isComplete(),
            )

        private fun row(item: SetupItemDto): SetupRow =
            SetupRow(item.label, item.detail, glyph(item.state), item.fix)

        private fun glyph(state: SetupItemStateDto): SetupGlyph =
            when (state) {
                SetupItemStateDto.DONE -> SetupGlyph.Done
                SetupItemStateDto.WARNING -> SetupGlyph.Warning
                SetupItemStateDto.BROKEN -> SetupGlyph.Broken
                SetupItemStateDto.TODO -> SetupGlyph.Todo
                SetupItemStateDto.OPTIONAL -> SetupGlyph.Optional
            }
    }
}
